import { doc, GeoPoint, getDoc, setDoc, Timestamp, updateDoc } from "firebase/firestore";
import { auth, firestore } from "./firebase";
import { signInWithEmailAndPassword, signOut, updatePassword, verifyBeforeUpdateEmail } from "firebase/auth";
export const signIn = async (email, password)=>{
    try {
        const result = await signInWithEmailAndPassword(auth, email, password).then(async (userCredential)=>{
            const user = userCredential.user;
            const token = await user.getIdToken();
            const response = await fetch('/api/auth/sign-in', {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    token: token
                })
            });
            const responseData = await response.json();
            if (response.ok && responseData.success) {
                const userRef = doc(firestore, 'users', user.uid);
                const userDoc = await getDoc(userRef);
                let result = null;
                if (userDoc.exists()) {
                    const data = userDoc.data();
                    if (data.history) {
                        await updateDoc(userRef, {
                            history: [
                                ...data.history,
                                {
                                    last_login_time: Timestamp.now(),
                                    user_agent: navigator.userAgent,
                                    geo: responseData.lat && responseData.lon ? new GeoPoint(parseFloat(responseData.lat), parseFloat(responseData.lon)) : null
                                }
                            ]
                        });
                    } else {
                        await updateDoc(userRef, {
                            history: [
                                {
                                    last_login_time: Timestamp.now(),
                                    user_agent: navigator.userAgent,
                                    geo: responseData.lat && responseData.lon ? new GeoPoint(parseFloat(responseData.lat), parseFloat(responseData.lon)) : null
                                }
                            ]
                        });
                    }
                    result = {
                        success: true,
                        user_type: data.user_type
                    };
                } else {
                    var _user_displayName, _user_displayName1;
                    // This edge case exists if the user account exists in Firebase Auth but not Firestore, which should only happen if they are coming from our B2B platform and haven't logged into the consumer platform before. In this case, we create a new user document for them in Firestore with the information we have from Firebase Auth and the request.
                    const usersRef = doc(firestore, 'users', user.uid);
                    const geoPoint = responseData.lat && responseData.lon ? new GeoPoint(parseFloat(responseData.lat), parseFloat(responseData.lon)) : null;
                    const userData = {
                        first_name: ((_user_displayName = user.displayName) === null || _user_displayName === void 0 ? void 0 : _user_displayName.split(' ')[0]) || '',
                        last_name: ((_user_displayName1 = user.displayName) === null || _user_displayName1 === void 0 ? void 0 : _user_displayName1.split(' ')[1]) || '',
                        user_type: 'Customer',
                        history: [
                            {
                                last_login_time: Timestamp.now(),
                                user_agent: navigator.userAgent,
                                geo: geoPoint
                            }
                        ],
                        created_at: Timestamp.now()
                    };
                    await setDoc(usersRef, userData);
                    result = {
                        success: true,
                        user_type: userData.user_type
                    };
                }
                return result;
            } else {
                console.log('Error signing in: ', responseData.data);
                await logOut();
                return {
                    success: false,
                    user_type: null
                };
            }
        });
        return result;
    } catch (error) {
        console.error('Error during sign in: ', error);
        return {
            success: false,
            user_type: null
        };
    }
};
export const logOut = async ()=>{
    try {
        await signOut(auth);
        const response = await fetch('/api/auth/sign-out', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const data = await response.json();
        if (response.ok && data.success) {
            return true;
        } else {
            return false;
        }
    } catch (error) {
        console.error(error);
        return false;
    }
};
export const firebaseEmailReset = async (currentUser, newEmail)=>{
    try {
        await verifyBeforeUpdateEmail(currentUser, newEmail);
        await logOut();
    } catch (error) {
        console.error('Error updating email: ', error);
    }
};
export const firebasePasswordReset = async (currentUser, newPassword)=>{
    try {
        await updatePassword(currentUser, newPassword);
        await logOut();
    } catch (error) {
        console.error('Error updating password: ', error);
    }
};
